import { userPermissions } from "@redotech/account-common/permissions";
import { unaryRpc } from "@redotech/rpc/definition";
import * as zExt from "@redotech/rpc/ext";
import { createEnum } from "@redotech/zod-util/zod-enum";
import * as z from "zod";

export const getUserPermissions = unaryRpc({
  name: "getUserPermissions" as const,
  input: z.object({}),
  output: z.object({
    permissions: zExt.filterToValidArray(createEnum(userPermissions)),
  }),
  mock: { permissions: [...userPermissions] },
});
